<template>
  <v-dialog persistent v-bind="[$attrs, $props]" width="495">
    <div class="pt-10 pl-7 pr-8 pb-8 white">
      <v-row class="pb-10">
        <v-col cols="12">
          <p class="font-weight-bold primary--text text-h6 mb-2">
            {{ titleModal }} COM SUCESSO!
          </p>
          <p class="primary--text font-weight-medium">
            Você deseja adicionar {{ textModal }}
          </p>
        </v-col>
      </v-row>
      <v-row>
        <v-spacer />
        <v-col cols="12" sm="4" md="3" xl="2" class="pr-sm-2">
          <BaseButton
            v-html="'NÃO'"
            color="secondary"
            outlined
            width="100%"
            @click="closeModal"
          />
        </v-col>
        <v-col cols="12" sm="4" md="3" xl="2">
          <BaseButton
            v-html="'SIM'"
            class="secondary white--text"
            width="100%"
            @click="submit"
          />
        </v-col>
      </v-row>
    </div>
  </v-dialog>
</template>
<script>
export default {
  computed: {
    titleModal() {
      return this.type == "tribunal"
        ? "TRIBUNAL ADICIONADO"
        : "VARA ADICIONADA";
    },
    textModal() {
      return this.type == "tribunal"
        ? "um novo tribunal"
        : `uma nova vara para o tribunal ${this.court}?`;
    }
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    submit() {
      this.$emit("submit");
    }
  },
  props: {
    type: {
      type: String
    },
    court: {
      type: String,
      default: null
    }
  }
};
</script>
